const alphabetise = (array) =>
  array.sort((a, b) => a.label.localeCompare(b.label));

export default alphabetise;
